import React from 'react';
import ReactDOM from 'react-dom';
import get_bundle from '../../domain/get_bundle';
import Password from '../../domain/Password';
import Color from '../../domain/Color';
import DefaultUi from '../DefaultUi';
import User from '../../domain/User';
import Alert from '../Alert';
import t from 'tcomb-form';
import { props } from 'tcomb-react';

const FormType = t.struct({
  old_password: Password,
  new_password: Password,
  confirm_password: Password
});

@props({
  locale: t.Obj,
  doChangePassword: t.Func,
  user: User,
  themeBtnColor: t.maybe(Color),
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  message: t.maybe(t.ReactElement),
  goAccount: t.Func,
  goChangePassword: t.Func,
  goPurchases: t.Func,
  doLogout: t.Func,
  doAcceptCookies: t.Func
})
export default class ChangePassword extends React.Component {

  constructor(...args){
    super(...args);
    this.state = {
      options: this.getOptions()
    };
  }

  getOptions() {
    const bundle = get_bundle(this.props.locale).change_password;
    return {
      fields: {
        old_password: {
          label: bundle.current_password,
          type: 'password',
          minLength: 6
        },
        new_password: {
          label: bundle.new_password,
          type: 'password',
          minLength: 6
        },
        confirm_password: {
          label: bundle.confirm_password,
          type: 'password',
          minLength: 6
        }
      }
    };
  }

  onSubmit = (evt) => {
    evt.preventDefault();
    const bundle = get_bundle(this.props.locale).change_password;
    const value = this.refs.form.getValue();

    if (value) {
      if (value.new_password !== value.confirm_password) {
        ReactDOM.render(
          <Alert type='error'>
            {bundle['confirm_password_error']}
          </Alert>,
          document.getElementById('message')
        );
      }
      else {
        this.props.doChangePassword(value.old_password, value.new_password);
      }
    }
  }

  render() {

    const { locale } = this.props;
    const bundle = get_bundle(locale).change_password;

    const btnStyle = {
      backgroundColor: this.props.themeBtnColor,
      color: this.props.themeBtnFontColor
    };

    return (
      <DefaultUi id="change_password" title={bundle.title} themeBgColor={this.props.themeBgColor} themeBgFontColor={this.props.themeBgFontColor}>
        <div id="message">
          { this.props.message }
        </div>
        <form onSubmit={this.onSubmit}>
          <t.form.Form
            ref="form"
            type={FormType}
            options={this.state.options} />
          <button className="btn" style={btnStyle}>{bundle.do_save}</button>
         </form>
      </DefaultUi>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/content/ChangePassword.js
 **/